"use client";

import { createContext, useContext } from "react";
import {
  DEFAULT_ORGANIZATION_PROFILE,
  type OrganizationProfile,
} from "@/lib/site/organization-profile";

const OrganizationProfileContext = createContext<OrganizationProfile>(
  DEFAULT_ORGANIZATION_PROFILE,
);

export function OrganizationProfileProvider({
  profile,
  children,
}: {
  profile: OrganizationProfile;
  children: React.ReactNode;
}) {
  return (
    <OrganizationProfileContext.Provider value={profile}>
      {children}
    </OrganizationProfileContext.Provider>
  );
}

export function useOrganizationProfile(): OrganizationProfile {
  return useContext(OrganizationProfileContext);
}
